<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperInventoryRequestsBooks',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'inventoryRequestsBooksModule',
    };
  },
};
</script>
